// import React from "react";
// import { Helmet } from "react-helmet";

// export const SEO = ({ title, description, meta = [] }) => {
//   return (
//     <Helmet
//       title={title}
//       htmlAttributes={{ lang: "en" }}
//       meta={[
//         {
//           name: `description`,
//           content: description,
//         },
//       ]}
//     />
//   );
// };

import { Helmet } from "react-helmet";
import React from "react";
import { TRADESBARN } from "../../constants";
const SEO = ({ title, description, keywords, image }) => {
  const seoImage = image || process.env.REACT_APP_BUSINESS_NAME === TRADESBARN ? 'https://firebasestorage.googleapis.com/v0/b/tradesbarn-content/o/emails%2Flogo_2.png?alt=media' : 'https://firebasestorage.googleapis.com/v0/b/onshop-content/o/emails%2Flogo_2.png?alt=media'
  return (
    <Helmet
      htmlAttributes={{ lang: "en" }}
      title={title}
      meta={[
        {
          name: "description",
          content: description || title,
        },
        // {
        //   name: "keywords",
        //   content: keywords.join(),
        // },
        {
          name: "keywords",
          content:
            "Buy & sell electronics, Fashion, Business & Industrial, Collectibles & Art, Home & Garden, Motors, Music, Sporting Goods, Toys & Hobbies & more on Treadesbarn, the world's online marketplace. Top brands, low prices & free shipping on many items.",
        },
        {
          name: "thumbnail",
          content: seoImage
        },
        {
          property: "og:image",
          content: seoImage,
        },
        {
          property: "twitter:image",
          content: seoImage,
        },
        {
          property: "og:title",
          content: title,
        },
        {
          property: "twitter:title",
          content: title,
        },
        {
          property: "twitter:site",
          content: `${process.env.REACT_APP_BUSINESS_NAME}`,
        },
        {
          property: "og:site_name",
          content: `@${process.env.REACT_APP_BUSINESS_NAME}`,
        },
        {
          property: "og:url",
          content: `${process.env.REACT_APP_BASE_URL}${window.location.pathname.replace(/\/,/, '')}`,
        },
      ]}
    />
  );
};
export default SEO;

// SEO.defaultProps = {
//   image: "Rahul",
//   eyeColor: "deepblue",
//   age: "45"
// }

// // OpenGraph tags (marked with og:) are crawled by Facebook whenever you share a link through Messenger/ Facebook:
// meta={[
//   {
//     property: "og:url",
//     content: someUrl
//   },
//   {
//     property: "og:type",
//     content: someArticle
//   },
//   {
//     property: "og:title",
//     content: someTitle
//   },
//   {
//     property: "og:description",
//     content: someDescription
//   },
//   {
//     property: "og:image",
//     content: someImage
//   },
//   {
//     property: "fb:app_id",
//     content: someFbAppId
//   }
// ]

// // Twitter tags (marked with twitter) are crawled by Twitter accordingly:
// meta={[
//   {
//     property: "twitter:card",
//     content: someSummary
//   },
//   {
//     property: "twitter:creator",
//     content: someAuthorName
//   },
//   {
//     property: "twitter:title",
//     content: someTitle
//   },
//   {
//     property: "twitter:description",
//     content: someDescription
//   },
//   {
//     property: "twitter:image",
//     content: someImage
//   }
// ]
